import { theme } from "../../../../src/@rocketseat/gatsby-theme-docs/styles/theme";
import { normalizeThemeUIColors, filterStyles } from "@lekoarts/gatsby-theme-specimens";
import * as React from 'react';
export default {
  theme,
  normalizeThemeUIColors,
  filterStyles,
  React
};